import React from 'react';
import { Container, Card, Button, Row, Col, Form, Table } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import styles from '../../../styles.module.css';
import LaudoCardHeader from '../../../components/laudos/LaudoCardHeader';
import EspelhoStressHeader from './EspelhoStressHeader';

export default function EspelhoFarma() {
  const location = useLocation();
  const stress = location.state && location.state.stress;

  return (
    <>
      {/* Estilos inline para garantir a precisão do layout A4 e impressão */}
      <style>{`
        @page {
          size: A4;
          margin: 0;
        }
        @media print {
          #removeMe {
            display: none !important;
          }

          .page {
            page-break-after: always;
          }

          .page:first-of-type {
            margin-top: 0;
          }

          .page:last-of-type {
            margin-bottom: 0;
            page-break-after: auto;
          }

          body {
            -webkit-print-color-adjust: exact;
          }
          .a4-container {
            box-shadow: none !important;
            margin: 0 !important;
            border: none !important;
          }
        }
        .a4-container {
          width: 210mm;
          height: 297mm;
          padding: 15mm 20mm;
          margin: 20px auto;
          background: #fff;
          box-shadow: 0 0 10px rgba(0,0,0,0.1);
          font-family: Arial, sans-serif;
          font-size: 11px;
          color: #000;
          line-height: 1.2;
        }
        .form-check-input {
          border: 2px solid #000 !important;
          border-radius: 0 !important;
          width: 16px;
          height: 16px;
          margin-top: 2px;
        }
        .form-check-label {
          font-weight: bold;
          padding-left: 5px;
          font-size: 14px;
        }
        .custom-table th {
          border: 1px solid #000 !important;
          padding: 6px !important;
          height: 35px;
          vertical-align: middle;
          font-size: 14px;
          font-weight: bold;
        }
        .line-input {
          border: none;
          border-bottom: 1px solid #000;
          border-radius: 0;
          padding: 0;
          height: auto;
          display: inline-block;
          background: transparent;
        }
        .line-input:focus {
          box-shadow: none;
          border-bottom: 1px solid #000;
        }
        .bold-label {
          font-size: 14px;
          font-weight: bold;
          margin: 0;
          padding: 0;
        }
      `}</style>

      <Container>
        <Card id="cardHeader">
          <div id="printMe">
            <LaudoCardHeader title="LAUDO DE ECO ESTRESSE - FARMACO" />

            <Card.Body>
              <Form noValidate className={styles.contentReport}>
                <EspelhoStressHeader stress={stress} />
                <Row className="mb-4">
                  <Col xs={8}>
                    <Form.Check
                      type="checkbox"
                      label="Checagem identificação pela enfermagem"
                      className="m-0"
                    />
                    <Form.Check
                      type="checkbox"
                      label="Checagem identificação pela equipe médica"
                      className="m-0"
                    />
                  </Col>
                  <Col xs={4}>
                    <div className="d-flex align-items-start">
                      <span className="bold-label m-2">INDICAÇÃO:</span>
                      <div className="w-100">
                        <Form.Check
                          type="checkbox"
                          label="pré op"
                          className="m-0 d-flex align-items-center"
                        />

                        <Form.Check
                          type="checkbox"
                          label="assintomát."
                          className="m-0 d-flex align-items-center"
                        />
                        <Form.Check
                          type="checkbox"
                          label="dor típica"
                          className="m-0 d-flex align-items-center"
                        />
                        <Form.Check
                          type="checkbox"
                          label="dor atípica"
                          className="m-0 d-flex align-items-center"
                        />
                        <Form.Check
                          type="checkbox"
                          label="IAM prévio"
                          className="m-0 d-flex align-items-center"
                        />

                        <Row>
                          <Col xs={6}>
                            <Form.Check
                              type="checkbox"
                              label="ATC"
                              className="m-0 d-flex align-items-center"
                            />
                          </Col>
                          <Col xs={6}>
                            <Form.Check
                              type="checkbox"
                              label="RM"
                              className="m-0 d-flex align-items-center"
                            />
                          </Col>
                        </Row>

                        <Row>
                          <Col xs={6}>
                            <Form.Check
                              type="checkbox"
                              label="DM"
                              className="m-0 d-flex align-items-center"
                            />
                          </Col>
                          <Col xs={6}>
                            <Form.Check
                              type="checkbox"
                              label="HAS"
                              className="m-0 d-flex align-items-center"
                            />
                          </Col>
                        </Row>

                        <Form.Check
                          type="checkbox"
                          label="dislipidemia"
                          className="m-0 d-flex align-items-center"
                        />
                        <Form.Check
                          type="checkbox"
                          label="tabagismo"
                          className="m-0 d-flex align-items-center"
                        />
                        <Form.Check
                          type="checkbox"
                          label="hist.familiar"
                          className="m-0 d-flex align-items-center"
                        />
                        <Form.Check
                          type="checkbox"
                          label="obst.art.per."
                          className="m-0 d-flex align-items-center"
                        />

                        <Row>
                          <Col xs={6}>
                            <Form.Check
                              type="checkbox"
                              label="asma"
                              className="m-0 d-flex align-items-center"
                            />
                          </Col>
                          <Col xs={6}>
                            <Form.Check
                              type="checkbox"
                              label="glau"
                              className="m-0 d-flex align-items-center"
                            />
                          </Col>
                        </Row>

                        <Form.Check
                          type="checkbox"
                          label="próstata"
                          className="m-0 d-flex align-items-center"
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
                {/* CATE e Fórmulas */}
                <div style={{ marginTop: '-180px', width: '85%' }}>
                  <Row className="mb-3 align-items-center">
                    <Col xs="auto" className="m-0 p-0">
                      <span className="bold-label">CATE:________</span>
                    </Col>

                    <Col xs="auto" className="m-0 p-0">
                      <span className="bold-label">CD:_______</span>
                    </Col>
                    <Col xs="auto" className="m-0 p-0">
                      <span className="bold-label">DA:________</span>
                    </Col>
                    <Col xs="auto" className="m-0 p-0">
                      <span className="bold-label">Dg:________</span>
                    </Col>
                    <Col xs="auto" className="m-0 p-0">
                      <span className="bold-label">Mg:________</span>
                    </Col>
                    <Col xs="auto" className="m-0 p-0">
                      <span className="bold-label">CX:_______</span>
                    </Col>
                  </Row>

                  <Row
                    className="mb-4 g-2 align-items-center"
                    style={{ fontSize: '11px' }}
                  >
                    <Col xs="auto" className="m-0 p-0">
                      <span className="bold-label">
                        FCMAX: (220-Id)=__________
                      </span>
                    </Col>
                    <Col xs="auto" className="m-0 p-0">
                      <span className="bold-label">x85%=__________</span>
                    </Col>
                    <Col xs="auto" className="m-0 p-0">
                      <span className="bold-label">
                        FCSubMAX=(195-Id)________
                      </span>
                    </Col>
                  </Row>

                  <Row className="mb-4 align-items-center">
                    <Col xs="auto" className="m-0 p-0">
                      <span className="bold-label">
                        Medicação
                        Uso:_________________________________________________________________
                        _______________________________________________________________________________
                        _______________________________________________________________________________
                      </span>
                    </Col>
                  </Row>

                  <Row className="mb-4 align-items-center">
                    <Col xs="auto" className="m-0 p-0">
                      <span className="bold-label">
                        Dobutamina 250mg-4ml + S.F.-0,9% - 96ml Aplicar IV acm
                      </span>
                    </Col>
                  </Row>

                  <Row className="mb-4 align-items-center">
                    <Col xs="auto" className="m-0 p-0">
                      <span className="bold-label">
                        Lote:_______________________
                      </span>
                    </Col>
                    <Col xs="auto" className="m-0 p-0">
                      <span className="bold-label">Val:_____/_____/______</span>
                    </Col>
                  </Row>
                </div>
                {/* Tabela Principal */}
                <Table
                  responsive
                  className="custom-table text-center mt-5 mb-4"
                >
                  <thead>
                    <tr>
                      <th style={{ width: '15%' }}>DOSE</th>
                      <th style={{ width: '15%' }}>Ml/h</th>
                      <th style={{ width: '15%' }}>PA</th>
                      <th style={{ width: '15%' }}>FC</th>
                      <th style={{ width: '25%' }}>SINTOMAS</th>
                      <th style={{ width: '15%' }}>ECG</th>
                    </tr>
                  </thead>
                  <tbody>
                    {['5mcg', '10mcg', '20mcg', '30mcg', '40mcg'].map(
                      (dose, index) => (
                        <tr key={index}>
                          <td></td>
                          <td className="bold-label">{dose}</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      )
                    )}
                  </tbody>
                </Table>
                {/* Seção Atropina / Metoprolol */}
                <Row className="mb-2 align-items-center">
                  <Col xs="auto" className="m-0 p-0">
                    <Form.Check
                      type="checkbox"
                      label="Atropina 0,25mg __________"
                      className="m-0 d-flex align-items-center"
                    />
                  </Col>
                  <Col xs="auto" className="m-0 p-0">
                    <span className="bold-label">
                      Lote:_______________________
                    </span>
                  </Col>
                  <Col xs="auto" className="m-0 p-0">
                    <span className="bold-label">Val:_____/_____/______</span>
                  </Col>
                </Row>
                <Row className="mb-4 align-items-center">
                  <Col xs="auto" className="m-0 p-0">
                    <Form.Check
                      type="checkbox"
                      label="Metoprolol 1ml __________"
                      className="mr-2 d-flex align-items-center"
                    />
                  </Col>
                  <Col xs="auto" className="m-0 p-0">
                    <Form.Check
                      type="checkbox"
                      label="Breviblok 10ml __________"
                      className="m-0 d-flex align-items-center"
                    />
                  </Col>
                  <Col xs="auto" className="m-0 p-0">
                    <span className="bold-label">
                      Lote:_______________________
                    </span>
                  </Col>
                  <Col xs="auto" className="m-0 p-0">
                    <span className="bold-label">Val:_____/_____/______</span>
                  </Col>
                </Row>
                {/* Rodapé Diagnóstico */}
                <Row className="mb-3">
                  <Col xs={4}>
                    <span className="bold-label">ECO-BASAL:</span>
                  </Col>
                  <Col xs={4}>
                    <span className="bold-label">VIABILIDADE:</span>
                  </Col>
                  <Col xs={4}>
                    <span className="bold-label">ISQUEMIA:</span>
                  </Col>
                </Row>
                <br></br>
                <Row className="mb-5 align-items-center g-1">
                  <Col xs="auto">
                    <span className="bold-label">OBS:</span>
                  </Col>
                  <Col>
                    <Form.Control className="line-input" size="sm" />
                  </Col>
                </Row>
                <br></br>
                {/* Assinaturas e Liberação */}
                <Row
                  className="pt-4 justify-content-between text-start"
                  style={{ fontSize: '12px' }}
                >
                  <Col xs="auto">
                    <span className="bold-label">LIBERAÇÃO:</span>
                  </Col>
                  <Col xs="auto">
                    <span className="bold-label">PA:</span>
                  </Col>
                  <Col xs="auto">
                    <span className="bold-label">HORÁRIO:</span>
                  </Col>
                  <Col xs="auto" className="pe-5">
                    <span className="bold-label">ASSINATURA:</span>
                  </Col>
                </Row>
              </Form>
            </Card.Body>
          </div>
          <div id="removeMe" className="text-right">
            <Button variant="outline-primary" onClick={() => window.print()}>
              Imprimir
            </Button>
          </div>
        </Card>
      </Container>
    </>
  );
};
